/** Max concurrent probe workers (lists or detail views). */
export const PROBE_CONCURRENCY = 4

export const ProbeConcurrency = {
  runWithConcurrency: async <T, R>(
    items: readonly T[],
    concurrency: number,
    worker: (item: T, index: number) => Promise<R>,
  ): Promise<R[]> => {
    if (items.length === 0) {
      return []
    }

    const results = new Array<R>(items.length)
    let nextIndex = 0

    const runWorker = async (): Promise<void> => {
      while (nextIndex < items.length) {
        const index = nextIndex
        nextIndex += 1
        results[index] = await worker(items[index], index)
      }
    }

    await Promise.all(
      Array.from({ length: Math.min(concurrency, items.length) }, () =>
        runWorker(),
      ),
    )

    return results
  },
}
